var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{class:{
        'hover': _vm.hover,
        'sort-active': _vm.isSortActive,
        'flex-table-no-wrap': !_vm.column.wrapText,
    },style:({
        width: _vm.column.width,
    }),on:{"mouseover":_vm.onMouseOver,"mouseout":_vm.onMouseOut,"click":_vm.onClick}},[(_vm.column.columnTemplate)?[_c('column-template',{attrs:{"column":_vm.column,"rows":_vm.rows}})]:[_vm._v("\n        "+_vm._s(_vm.column.label)+"\n    ")],_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSortDesc),expression:"showSortDesc"}],staticClass:"fa-solid fa-caret-down sort-icon"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSortAsc),expression:"showSortAsc"}],staticClass:"fa-solid fa-caret-up sort-icon"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }